import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import Popup from '~shared/components/organisms/Popup/index'
import PopupBox from '~shared/components/popup/PopupBox'
import PopupContent from '~shared/components/popup/PopupContent'
import PopupHeader from '~shared/components/popup/PopupHeader'
import Subscriber from '~shared/utils/Subscriber'
import PopupContext from '~shared/components/popup/PopupContext'
import { useWidth } from '~src/new/app/providers/WidthProvider'
import { SidebarModal } from '~src/new/shared/ui/SidebarModal'

const PopupWrapper = props => {
  const { isMobile } = useWidth()
  const onCloseSubscriberRef = useRef(null)
  const popupRef = useRef(null)

  if (!onCloseSubscriberRef.current) {
    onCloseSubscriberRef.current = new Subscriber()
  }

  const handlePopupClose = useCallback(event => {
    onCloseSubscriberRef.current.dispatch(event)
  }, [])

  useEffect(
    () => () => {
      onCloseSubscriberRef.current.reset()
    },
    [],
  )

  const contextValue = useMemo(
    () => ({
      popup: true,
      listenToOuterClose: onCloseSubscriberRef.current.subscribe,
      popupRef,
    }),
    [],
  )

  const {
    wrap,
    onClose,
    children,
    isOpen,
    preventCickOutside,
    componentName,
    /*minWidth,*/ maxWidth,
    /*minHeight,*/ maxHeight,
    props: wrapperProps,
  } = props

  const { isSidebar, isSheetModal } = wrapperProps

  const commonProps = useMemo(
    () => ({
      'data-popup-id': componentName,
      open: isOpen,
      id: 'popup-wrapper',
    }),
    [componentName, isOpen],
  )

  const sheetCondition = useMemo(() => {
    return isOpen && isMobile && !preventCickOutside && !isSidebar && isSheetModal
  }, [isOpen, isMobile, preventCickOutside, isSidebar, isSheetModal])

  if (!children) return null

  if (sheetCondition) {
    return children
  }

  if (isSidebar) {
    return <SidebarModal {...props}>{children}</SidebarModal>
  }

  return wrap ? (
    <Popup {...commonProps} onClose={onClose} rootRef={popupRef}>
      <PopupBox onClose={onClose} maxWidth={maxWidth} maxHeight={maxHeight}>
        <PopupHeader />
        <PopupContent>
          <PopupContext.Provider value={contextValue}>{children}</PopupContext.Provider>
        </PopupContent>
      </PopupBox>
    </Popup>
  ) : (
    <Popup
      {...commonProps}
      disableBackdropClick={preventCickOutside}
      disableEscapeKeyDown={preventCickOutside}
      onClose={handlePopupClose}
      rootRef={popupRef}
    >
      <PopupContext.Provider value={contextValue}>{children}</PopupContext.Provider>
    </Popup>
  )
}

export default PopupWrapper
